import React from 'react';
import { Route as RouteDefinition } from '../../../types/route';
import SubNavBarDesktop from './Desktop';
import SubNavBarMobile from './Mobile';
import { PapiUser } from '@wix/da-types-papi';
import { withMobileContext } from '@wix/da-shared-react/pkg/Context/MobileContext';

export interface SubNavBarProps {
  routes: RouteDefinition[];
  profileOwnerUser: PapiUser;
  isWatchingProfileOwner: boolean;
  isOwner: boolean;
  isMobile?: boolean;
}

class SubNavBar extends React.Component<SubNavBarProps> {
  render() {
    return this.props.isMobile ? (
      <SubNavBarMobile {...this.props} />
    ) : (
      <SubNavBarDesktop {...this.props} />
    );
  }
}

export default withMobileContext(SubNavBar);
